<template>
  <div class="row">
    <RolledSection>
      <div slot="icon-beafore-title"><icon icon="drag-indicator" /></div>
      <div slot="header">Rich content {{ index + 1 }} #id {{ content.id }}</div>
      <div slot="button">
        <div
          class="button-icon button-icon--ml-10"
          @click="deleteContent(index), $root.$emit('productIsChanged')"
        >
          <icon icon="trash" icon-classes="icon--grey button-icon--gray" />
        </div>
      </div>
      <div slot="body" class="row product-form--gray pb-4 mb-4">
        <div class="col-24">
          <InputTreeselect
            :options="dictionaries.content_options"
            :object="content"
            :isLoading="isLoading"
            fieldName="product_content_option_id"
            label="Układ Kontentu"
            @additionalFunction="changeContentLayout"
          ></InputTreeselect>
        </div>
        <div
          class="col-24  col-xl-12"
          v-if="content.product_content_option_id != 4"
        >
          <InputSimple
            :object="content"
            label="Tytuł"
            fieldName="title"
            type="text"
          ></InputSimple>
        </div>
        <div
          class="col-24 col-xl-12"
          v-if="content.product_content_option_id != 4"
        >
          <InputSimple
            :object="content"
            label="Podtytuł"
            fieldName="subtitle"
            type="text"
          ></InputSimple>
        </div>
        <div class="col-24" v-if="content.product_content_option_id != 4">
          <EditorForm fieldName="description" :object="content" label="Opis">
          </EditorForm>
        </div>
        <div
          class="col-24 col-xl-12"
          v-if="content.product_content_option_id != 3"
        >
          <Photos
            :photos="[content.photo]"
            :multiplePhotos="false"
            :itemIndex="index"
            folderPath="contents/"
            @delete="deletePhoto"
            @add="addPhoto"
            labelName="Zdjęcie"
          ></Photos>
        </div>
      </div>
    </RolledSection>
  </div>
</template>
<script>
import Icon from "../parts/Icon";
import Photos from "./Photos";
import InputTreeselect from "./forms/InputTreeselect.vue";
import InputSimple from "./forms/InputSimple.vue";
import EditorForm from "./forms/EditorForm.vue";
import RolledSection from "./forms/RolledSection.vue";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  props: {
    content: {
      type: Object,
      required: false,
    },
    index: {
      type: Number,
      required: false,
    },
    dictionaries: {
      type: Object,
      required: false,
    },
  },
  components: {
    Icon,
    Photos,
    InputTreeselect,
    InputSimple,
    EditorForm,
    RolledSection,
  },
  methods: {
    changeContentLayout(content) {
      if (content.product_content_option_id == 3) {
        content.photo = { id: null, path: null };
      } else if (content.product_content_option_id == 4) {
        content.title = null;
        content.subtitle = null;
        content.description = null;
      }
    },
    deletePhoto() {
      this.content.photo = { id: null, path: null };
    },
    addPhoto(photo) {
      this.content.photo = photo;
    },
    deleteContent(index) {
      this.$emit("deleteContent", index);
    },
  },
};
</script>
